export const SaleEndDate = new Date('2026-01-02T00:00:00Z');
